enum Error {
  COMMON = 'Lỗi không xác định từ máy chủ. Vui lòng thử lại!',
  LOCKED = 'Tài khoản của bạn đang bị khóa, mời bạn liên hệ Ban Quản trị để mở khóa.',
}

export default Error;
